


























import Vue from 'vue';
import { notify } from '@/web/utils/notify';

export default Vue.extend({
  name: 'HMWidgetCodeModal',
  props: {
    title: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },
  methods: {
    copy(id: string, value: string): void {
      const element = document.getElementById(id)!;
      const range = document.createRange();
      range.selectNode(element);
      const selection = window.getSelection()!;
      selection.removeAllRanges();
      selection.addRange(range);

      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED') as string, this.title);
      });

      setTimeout(() => selection.removeAllRanges());
    },
  },
});
